import React from 'react';
import PageLoadingBlockage from '../pageLoadingBlockage/pageLoadingBlockage';
import {connect} from 'react-redux';
import LoginModal from '../loginModal/loginModal';
import logo from '../../assets/logo/logo512.png';
import styles from './layout.module.css';

const Layout = ({children, loading, loginModalVisible}) => (
    <div>
        <a className={styles.logoWraper} href={'https://herbzy.space/'}>
            <img className={styles.logo} src={logo} alt="logo" />
        </a>
        {children}
        {loginModalVisible && <LoginModal />}
        {loading && <PageLoadingBlockage />}
    </div>
);

const mapStateToProps = state => ({
    loginModalVisible: state.ui.loginModalVisible,
    loading: state.ui.loading,
});

export default connect(mapStateToProps)(Layout);
